import Header from "./header";
import Footer from "./footer";

/* SMOOTH SCROLLING */
import SmoothScrolling from "components/lenis";

const Layout = ({ children }) => {
  return (
    <main className="app">
      <Header />
      <SmoothScrolling>{children}</SmoothScrolling>
      <Footer />
    </main>
  );
};

export default Layout;
